
import React, { useState, useEffect } from 'react';
import { Modal, Row, Col, Card, Form, Button, Badge } from 'react-bootstrap';
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { toast } from "react-toastify";
import Loader from '../loader/Loader';
const MachineMaintenanceModal = ({ show, handleClose, maintenanceId }) => {
  const [maintenance, setMaintenance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    maintenance_date: "",
    days_required: "",
    maintenance_type: ""
  });
  useEffect(() => {
    if (show && maintenanceId) {
      fetchMaintenanceDetails(maintenanceId);
    }
  }, [show, maintenanceId]);
  const fetchMaintenanceDetails = async (id) => {
    const token = getAuthToken();
    if (!token) return;
     setLoading(true);
    try {
      const response = await axios.get(`${config.API}/supervisor/maintenance/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = response?.data || null;
      setMaintenance(data);
      if (data?.maintenance) {
        setFormData({
          maintenance_date: data?.maintenance?.maintenance_date
            ? new Date(data?.maintenance?.maintenance_date).toISOString().split("T")[0]
            : "",
          days_required: data?.maintenance?.days_required || "",
          maintenance_type: data?.maintenance?.maintenance_type || ""
        });
      }
    } catch (err) {
      console.error("Error fetching maintenance:", err.message);
      setMaintenance(null);
    }finally{
       setLoading(false);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const handleReschedule = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const res = await axios.put(
        `${config.API}/supervisor/maintenance/${maintenanceId}`,
        {
          maintenance_date: formData.maintenance_date,
          days_required: formData.days_required,
          maintenance_type: formData.maintenance_type,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(res.data.message || "Maintenance rescheduled successfully");
      handleClose();
    } catch (err) {
      toast.error(err.response?.data?.message || "Error rescheduling maintenance");
      console.error("Error updating:", err.response?.data || err.message);
    }
  };
  return (
    <Modal show={show} onHide={handleClose} size="lg" centered className='font_family'>
     {
      loading ?(
        <Loader/>
      ):(
         <Modal.Body className='p-5'>
        <strong className="fs-4 ">Machine Maintenance Schedule</strong>
        <Card className="p-3 bg-light border-0 mb-4 mt-4">
          <Row>
            <Col xs={6}>
              <div><strong>Code:</strong> <span className="fw-semibold">{maintenance?.maintenance?.machine?.machine_code}</span></div>
              <div><strong>Section:</strong> <span className="fw-semibold">{maintenance?.maintenance?.machine?.section  ?? "Rubber Moulding Section"}</span></div>
            </Col>
            <Col xs={6}>
              <div><strong>Type:</strong> <span className="fw-semibold">{maintenance?.maintenance?.machine?.type}</span></div>
              <div>
                <strong>Machine Status:</strong>{' '}
                <Badge bg="success-subtle" className="p-2 px-2 rounded-pill text-dark">
                  {maintenance?.maintenance?.machine?.status}
                </Badge>
              </div>
            </Col>
          </Row>
        </Card>
        <Form>
          <Row className="mb-3">
            <Col md={6}>
              <Row className="align-items-center">
                <Col md={6}><span>Date of Maintenance</span></Col>
                <Col md={6}>
                  <Form.Control
                    type="date"
                    name="maintenance_date"
                    value={formData.maintenance_date}
                    onChange={handleChange}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className="align-items-center">
                <Col md={6}><span>Days Required</span></Col>
                <Col md={6}>
                  <Form.Control
                    type="number"
                    name="days_required"
                    value={formData.days_required}
                    onChange={handleChange}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={2}><Form.Label>Maintenance Type</Form.Label></Col>
            <Col md={10}>
              <Form.Control
                as="textarea"
                rows={3}
                name="maintenance_type"
                value={formData.maintenance_type}
                onChange={handleChange}
              />
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      )
     }
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="dark" onClick={handleReschedule}>
          Reschedule
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MachineMaintenanceModal;
